// Critical Tests
import { veryOldErrorTest, oldErrorTest } from './critical/oldErrorTest'
import { oldVersionTest } from './critical/oldVersionTest'

// Base Game Tests
import { schedulingErrorTest } from './basegame/schedulingErrorTest'
import { animationStatesTraverseTest } from './basegame/animationStatesTraverseTest'
import { animationMissingJointTest } from './basegame/animationMissingJointTest'
import { postureGraphTest } from './basegame/postureGraphTest'
import { plexZonePositionTest } from './basegame/plexZoneTest'
import { inventoryErrorTest } from './basegame/inventoryErrorTest'
import { postureRuntimeErrorTest, postureFailedCarryHandError } from './basegame/postureRuntimeErrorTest'
import { animationZeroLengthDurationTest } from './basegame/animationZeroLengthDurationTest'
import { householdMilestoneTrackerTest } from './basegame/householdMilestoneTrackerTest'

// Mods Tests
import { wiwVersionTest } from './mods/wiwVersionTest'
import { wowVersionTest } from './mods/wowVersionTest'


import { lenaBunnyHeightSliderTest } from './mods/authors/lenaBunnyModsTest'
import { regalchromaggia69ModsTest } from './mods/authors/regalchromaggia69ModsTest'
import { mgomezModsTest } from './mods/authors/mgomezModsTest'
import { skillfulsimmer340ModsTest } from './mods/authors/skillfulsimmer340ModsTest'
import { sacrificialDeadlyToddlersTest, sacrificialExtremeViolenceTest } from './mods/authors/sacrificialModsTest'
import { ohMySimsModsTest } from './mods/authors/ohMySimsModsTest'
import { icemunmunModsTest } from './mods/authors/icemunmunModsTest'
import { littlemssamModsTest } from './mods/authors/littlemssamModsTest'

import { outdatedOutfitCategoryTuningTest } from './mods/outdatedOutfitCategoryTuningTest'
import { appearanceModifierErrorTest } from './mods/appearanceModifierErrorTest'
import { focusBoneErrorTest } from './mods/focusBoneErrorTest'
import { participantResolverErrorTest } from './mods/participantResolverErrorTest'
import { importErrorTest } from './mods/importErrorTest'
import { missingPackErrorTest } from './mods/missingPackErrorTest'
import { missingASMResourceErrorTest } from './mods/missingResourceErrorTest'
import { outdatedWhimsErrorTest } from './mods/outdatedWhimsErrorTest'
import { outdatedGenderTuningResourceTest } from './mods/outdatedTunableResourceTest'

import { tunableResourceTest1, tunableResourceTest2, tunableResourceTest3, tunableResourceTest4 } from './mods/tunableResourceTest'
import { outdatedFurnitureTest } from './mods/outdatedFurnitureTest'
import { situationSerializationErrorTest } from './mods/situationSerializationErrorTest'

// Potential Warnings
import { wwcnModTest } from './mods/wwcnModTest'
import { nisakModTest } from './mods/nisakModTest'


// Empty error file test
import { noReport } from './noReport'

export const testReports = [
    // Critical Tests
    veryOldErrorTest,
    oldErrorTest,
    oldVersionTest,

    // Mods Tests
    wiwVersionTest,
    wowVersionTest,

    lenaBunnyHeightSliderTest,
    regalchromaggia69ModsTest,
    mgomezModsTest,
    skillfulsimmer340ModsTest,
    sacrificialDeadlyToddlersTest,
    sacrificialExtremeViolenceTest,
    ohMySimsModsTest,
    icemunmunModsTest,
    littlemssamModsTest,

    outdatedOutfitCategoryTuningTest,
    appearanceModifierErrorTest,
    focusBoneErrorTest,
    participantResolverErrorTest,
    importErrorTest,
    missingPackErrorTest,
    missingASMResourceErrorTest,
    outdatedWhimsErrorTest,
    outdatedGenderTuningResourceTest,

    tunableResourceTest1,
    tunableResourceTest2,
    tunableResourceTest3,
    tunableResourceTest4,
    outdatedFurnitureTest,
    situationSerializationErrorTest,

    // Base Game Tests
    schedulingErrorTest,
    animationStatesTraverseTest,
    animationMissingJointTest,
    postureGraphTest,
    plexZonePositionTest,
    inventoryErrorTest,
    postureRuntimeErrorTest,
    postureFailedCarryHandError,
    animationZeroLengthDurationTest,
    householdMilestoneTrackerTest,

    // Potential Warnings
    wwcnModTest,
    nisakModTest,
]

export const testWhenNoReports = [
    noReport,
]



// WEBPACK FOOTER //
// ./src/tests/index.js